import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { GeneralSettingValueService, SocietiesService } from '@pwc-bei/common';
import { RoutePath } from 'src/app/enums/route-path.enum';
import { ESharedDocumentType } from 'src/app/enums/shared-document-type';
import { SharedDocumentUploadService } from 'src/app/services/shared-document/shared-document-upload.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-user-manual',
    templateUrl: './user-manual.component.html',
    styleUrls: ['./user-manual.component.scss'],
    standalone: false
})
export class UserManualComponent implements OnInit {

  public url: SafeResourceUrl;
  directChannel = environment.directChannel;
  urlString: string = 'https://www.youtube.com/embed/3QEB_v04-OE?controls=1';

  faChevronLeft = faChevronLeft;

  manualFileName: string;

  constructor(
    private societiesService: SocietiesService,
    private generalSettingValueService: GeneralSettingValueService,
    private sharedDocumentUploadService: SharedDocumentUploadService,
    private sanitizer: DomSanitizer,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlString);
    if(!this.directChannel){
      this.goToHomePage()
    }

    this.initUserManual();
  }

  goToHomePage(): void {
    this.router.navigate([RoutePath.HOME]);
  }

  private initUserManual(): void {
    // this.manualFileName = environment.esgEnabled ? environment.configuration.manualFileNameWithEsg : environment.configuration.manualFileName;
    // this.societiesService.getSelectedSociety()
    //   .pipe(
    //     switchMap((society: Society) => this.generalSettingValueService.findByCode('ECOBONUS_USER_MANUAL_B2C', society.id))
    //   )
    //   .subscribe((list: GeneralSettingValue[]) => {
    //     if (list == null || list.length === 0) {
    //       return;
    //     }

    //     const setting = list[0];
    //     this.manualFileName = setting.value;
    //   });
  }


  getB2CManual(): void{
    const docType = ESharedDocumentType.STD_USER_MANUAL_B2C;
    this.sharedDocumentUploadService.downloadDoc(docType);
  }


}
